import { APICallV4Post } from 'reactApp/api/APICall';

export class WeblinksSeoIndexedEnableAPIV4Call extends APICallV4Post<any, { weblink_id: string }> {
    _method = 'weblinks/seo/indexed/enable';
}
